export const ChargebacksPages = {
	ChargebacksQueue: {
		name: "chargebacks",
		displayName: "Chargebacks Queue",
	},
	ChargebacksDetails: {
		name: "chargebacksDetails",
		displayName: "Details",
	},
	Chargebacks: {
		name: "chargebacks",
		displayName: "Chargebacks",
	},
};
